<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  rentProgressPhases: { type: Array, default: () => [] },
  rentProgressPhase: { type: String, default: '' },
});

const emit = defineEmits(['select']);

const selectRentProgressPhase = value => emit('select', value);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div
    class="border-b border-lais-border bg-lais-bg-soft px-4 py-3 sm:px-6 lg:px-10"
  >
    <div class="flex gap-2 overflow-x-auto no-scrollbar">
      <button
        v-for="phase in rentProgressPhases"
        :key="phase.value"
        type="button"
        class="inline-flex h-9 shrink-0 items-center rounded-full border px-3 text-[13px] font-semibold transition-colors"
        :class="
          rentProgressPhase === phase.value
            ? 'border-lais-primary bg-white text-lais-primary shadow-lais-subtle'
            : 'border-lais-border bg-white text-lais-text-body hover:border-lais-primary hover:text-lais-primary'
        "
        @click="selectRentProgressPhase(phase.value)"
      >
        {{ phase.label }}
      </button>
    </div>
  </div>
</template>
